import AppHttpClient from '../api-manager/api/http-client';
import HttpPathsEnum from '../api-manager/api/http-paths.enum';
import { HttpRequest, RequestType } from '../api-manager/api/http-request';
import { ResourceResponseDto } from './dto/response/get-resources-response.dto';
import { BuildingsResponseDto } from './dto/response/get-buildings-response.dto';
import { GetLocationResponseDto } from './dto/response/get-location-response.dto';
import { IsaveResource } from '../../store/RoomManagement/resourceManagementTypes';
import { CreateResourceAllocResponseDto } from './dto/response/create-alloc-response.dto';
import { GetResourceByIdResponseDto } from './dto/response/get-resource-by-id-response.dto';

const RESOURCE_PATH = HttpPathsEnum.RESOURCE;

class RoomManagementApi {
  public async getResources(locationId?: number) {
    const request: HttpRequest = {
      url: `${RESOURCE_PATH}/resource/get-all-rooms?scope=${locationId}`,
      method: RequestType.GET,
    };

    return await AppHttpClient.exec<any, ResourceResponseDto[]>(
      request,
      ResourceResponseDto
    );
  }

  public async getResourceById(id: number) {
    const request: HttpRequest = {
      url: `${RESOURCE_PATH}/resource/${id}`,
      method: RequestType.GET,
    };

    return await AppHttpClient.exec<any, GetResourceByIdResponseDto>(
      request,
      GetResourceByIdResponseDto
    );
  }

  public async getValidResourceById(id: number) {
    const request: HttpRequest = {
      url: `${RESOURCE_PATH}/resource/find-valid-resource-by-id/${id}`,
      method: RequestType.GET,
    };

    return await AppHttpClient.exec<any, GetResourceByIdResponseDto>(
      request,
      GetResourceByIdResponseDto
    );
  }

  public async getResourceAvailableSlots(
    id: number,
    startDate: number,
    alloc_id?: number
  ) {
    const request: HttpRequest = {
      url: `${RESOURCE_PATH}/resource-alloc/slots`,
      method: RequestType.GET,
      params: {
        start_time: startDate,
        resource_id: id,
        alloc_id,
      },
    };

    return await AppHttpClient.exec<any, number[]>(request, []);
  }

  public async saveResourceAllocation(
    createResourceAllocDto: IsaveResource,
    creditBalanceDto: any
  ) {
    const request: HttpRequest = {
      url: `${RESOURCE_PATH}/resource-alloc`,
      method: RequestType.POST,
      data: {
        createResourceAllocDto,
        creditBalanceDto,
      },
    };

    return await AppHttpClient.exec<any, CreateResourceAllocResponseDto>(
      request,
      CreateResourceAllocResponseDto
    );
  }

  public async updateResourceAllocation(
    createResourceAllocDto: IsaveResource,
    creditBalanceDto: any
  ) {
    const request: HttpRequest = {
      url: `${RESOURCE_PATH}/resource-alloc/update-allocation`,
      method: RequestType.PATCH,
      data: {
        createResourceAllocDto,
        creditBalanceDto,
        resource_alloc_id: createResourceAllocDto.resource_alloc_id,
      },
    };

    return await AppHttpClient.exec<any, CreateResourceAllocResponseDto>(
      request,
      CreateResourceAllocResponseDto
    );
  }

  public async cancelBooking(activityId: number) {
    const request: HttpRequest = {
      url: `${RESOURCE_PATH}/resource-alloc/${activityId}`,
      method: RequestType.DELETE,
    };

    return await AppHttpClient.exec<any, boolean>(request, Boolean);
  }

  public async getAllBuildings(scope?: number) {
    const request: HttpRequest = {
      url: `${RESOURCE_PATH}/building?scope=${scope}`,
      method: RequestType.GET,
    };

    return await AppHttpClient.exec<any, BuildingsResponseDto[]>(
      request,
      BuildingsResponseDto
    );
  }

  public async getLocationById(id: number) {
    const request: HttpRequest = {
      url: `${RESOURCE_PATH}/location/${id}`,
      method: RequestType.GET,
    };

    return await AppHttpClient.exec<any, GetLocationResponseDto>(
      request,
      GetLocationResponseDto
    );
  }
}

export default new RoomManagementApi();
